var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-alert",
        { attrs: { value: _vm.auth_status === "loading", type: "info" } },
        [_vm._v(_vm._s(_vm.$t("login.inProgress")))]
      ),
      _c("div", { staticStyle: { display: "none" } }, [_vm._t("default")], 2),
      _vm.is_user_logged
        ? _c("div", [
            _c("h1", [_vm._v(_vm._s(_vm.$t("login.loginSuccess")))]),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("login.welcome")) + " "),
              _c("span", { domProps: { textContent: _vm._s(_vm.user_name) } })
            ])
          ])
        : _vm._e(),
      !_vm.is_user_logged && _vm.canSavePassword
        ? _c(
            "div",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.loginClick($event)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("login.company"),
                      rules: _vm.companyRules,
                      required: "",
                      name: "company"
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loginClick($event)
                      }
                    },
                    model: {
                      value: _vm.company,
                      callback: function($$v) {
                        _vm.company = $$v
                      },
                      expression: "company"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("login.login"),
                      rules: _vm.loginRules,
                      required: "",
                      name: "login"
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loginClick($event)
                      }
                    },
                    model: {
                      value: _vm.login,
                      callback: function($$v) {
                        _vm.login = $$v
                      },
                      expression: "login"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      name: "password",
                      label: _vm.$t("login.password"),
                      rules: _vm.passwordRules,
                      type: "password",
                      required: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loginClick($event)
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  }),
                  _c(
                    "small",
                    [
                      _vm._v(_vm._s(_vm.$t("login.forgottenPassword")) + " "),
                      _c(
                        "router-link",
                        { attrs: { to: "/profile/password-forgotten" } },
                        [_vm._v(_vm._s(_vm.$t("login.resetPassword")))]
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        type: "submit",
                        disabled: _vm.$store.getters["Ajax/loading"]
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("login.button")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.is_user_logged && !_vm.canSavePassword
        ? _c(
            "div",
            [
              _c(
                "form",
                {
                  staticStyle: { position: "absolute", top: "-800px" },
                  attrs: { autocomplete: "off" }
                },
                [
                  _c("input", {
                    attrs: {
                      label: _vm.$t("login.login"),
                      id: "lastName",
                      type: "text",
                      autocomplete: "new-password"
                    }
                  }),
                  _c("input", {
                    attrs: {
                      label: _vm.$t("login.password"),
                      type: "password",
                      id: "firstName",
                      autocomplete: "new-password"
                    }
                  })
                ]
              ),
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { autocomplete: "off" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("login.company"),
                      rules: _vm.companyRules,
                      autocomplete: "new-password",
                      required: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loginClick($event)
                      }
                    },
                    model: {
                      value: _vm.company,
                      callback: function($$v) {
                        _vm.company = $$v
                      },
                      expression: "company"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("login.login"),
                      rules: _vm.loginRules,
                      required: "",
                      autocomplete: "new-password"
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loginClick($event)
                      }
                    },
                    model: {
                      value: _vm.login,
                      callback: function($$v) {
                        _vm.login = $$v
                      },
                      expression: "login"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("login.password"),
                      rules: _vm.passwordRules,
                      type: "password",
                      required: "",
                      autocomplete: "new-password"
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loginClick($event)
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  }),
                  _c(
                    "small",
                    [
                      _vm._v(_vm._s(_vm.$t("login.forgottenPassword")) + " "),
                      _c(
                        "router-link",
                        { attrs: { to: "/profile/password-forgotten" } },
                        [_vm._v(_vm._s(_vm.$t("login.resetPassword")))]
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: _vm.$store.getters["Ajax/loading"] },
                      on: { click: _vm.loginClick }
                    },
                    [_vm._v(_vm._s(_vm.$t("login.button")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }